












import {
	computed,
	defineComponent,
	PropType,
} from '@vue/composition-api';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { UpsertModuleRequest } from '@front-app/api-generated/learning-management-api';
import {
	LearningProgram,
} from '../Model';
import { getLearningProgramsStore } from '../store/LearningProgramsStore';
import BaseModuleForm from './ModuleBaseForm.vue';

export default defineComponent({
	components: {
		BaseModuleForm,
	},
	props: {
		moduleId: {
			type: String,
			required: true,
		},
		program: {
			type: Object as PropType<LearningProgram>,
			required: true,
		},
		groupId: {
			type: String,
			required: true,
		},
	},
	setup(props, ctx) {
		const programsStore = getLearningProgramsStore();
		const learningModule = computed(() => programsStore.getModule(props.moduleId));

		// Submission
		const { track, isLoading, isError } = useAsyncStatus();
		const handleSubmit = async (payload: UpsertModuleRequest) => {
			await track(programsStore.updateModule(props.program.id, props.moduleId, payload));
			ctx.emit('updated');
		};

		return {
			learningModule,
			handleSubmit,
			isLoading,
			isError,
		};
	},
});
